/* eslint-disable */
export default {
  attachFiles: 'Anexar ficheiro',
};

// @key: @#@"attachFiles"@#@ @source: @#@"Attach file"@#@
